<template>
<div class="container">
  <fullCat v-if="showModal" />
  <navigation/>
  <div class="wrapper">
  <categoryInfo class="categoryInfo" v-bind:title="category" />
  <div class="grid-categories">
    <div v-for="item in items" :key="item.id" class="single-item">
      <div class="image" :style="`background-image: url('${item.url}'); background-size: cover; background-position: top; background-repeat: no-repeat`" @click="fullCategory(item)"></div>
      <h4>{{translate(item.name)}}</h4>
    </div>
  </div>
  </div>
      <div class="center">
      <router-link tag="button" class="backBtn" to="/szklografika">Wróć do wyboru kategorii</router-link>
      </div>
    <backTop/>
  <Footer/>
</div>
</template>

<script>
import backTop from '@/components/backTop.vue';
import fullCat from '@/components/fullCategory_modal.vue';
import navigation from '@/components/navigation.vue';
import Footer from '@/components/Footer.vue';
import categoryInfo from '@/components/categoryInfo.vue';
import { mapActions, mapState } from 'vuex';
export default {
  data(){
   return{
      category: this.$route.params.categoryName,
   }
  },
  components:{
    navigation,
    Footer,
    categoryInfo,
    fullCat,
    backTop
  },
  computed:{
    ...mapState({
      items: state => state.category.items,
      showModal: state => state.category.showModal
    })
  },
  methods:{
    ...mapActions(['queryData', 'fullCategory']),
    translate(title){
      return (title.substring(0, title.length - 4))
    }
  },
  mounted(){
      this.items.length = 0;
      this.queryData(this.category);
  }
}
</script>

<style scoped lang="scss">
.backBtn{
  color: white;
  background: black;
  border: none;
  padding: 12px 24px;
  margin: 24px 0;
}
.center{
  display: flex;
  justify-content: center;
  align-items: center;
}
.categoryInfo{
  margin-bottom: 22px;
}
#app{
  height: 100vh;
  width: 100%;
}
.container{
  height: 100%;
  width: 100%;
}
.wrapper{
  padding: 110px 34px 34px 34px;
}
.grid-categories{
  display: flex;
  justify-content: center;
  align-content: center;
  flex-wrap: wrap;
}
.single-item{
  margin: 0 12px;
}
.image{
  width: 120px;
  height: 120px;
  background-size: cover;
  background-position: center;
}
@media (min-width: 1440px){
  .wrapper{
    padding: 120px 100px;
    width: 100%;
  }
  .title{
    padding-left: 50px;
    font-size: 28px;
  }
  .image{
    width: 250px;
    height: 250px;
    transition: 0.3s;
    cursor: pointer;
    &:hover{
      box-shadow: 0 14px 28px rgba(0, 0, 0, 0.11), 0 10px 10px rgba(0, 0, 0, 0.075);
    }
  }
}
</style>